export default "__VITE_ASSET__DmiwHF_8__"